module.exports = __webpack_public_path__ + "static/media/instagram.d77f30af.svg";